import { FieldLabel, Input } from "@workspace/frontend-ui";
import { forwardRef } from "react";
import type { TextInputProps } from "./types";

const TextInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
  const { label, name, isError, className, ...inputProps } = props;

  return (
    <div>
      <FieldLabel
        className="text-muted-foreground text-base font-normal pb-2"
        htmlFor={name}
      >
        {label}
      </FieldLabel>
      <Input
        aria-invalid={isError}
        name={name}
        id={name}
        ref={ref}
        className={`h-10 md:text-base ring-0 border-2 ${className ?? ""}`}
        {...inputProps}
      />
    </div>
  );
});

export default TextInput;
